var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileExport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_1331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2175 14.8042C12.9271 14.5421 12.4738 14.5704 12.2188 14.8679C11.815 15.3283 11.2342 15.5904 10.625 15.5904H3.54167C2.37292 15.5904 1.41667 14.6342 1.41667 13.4654V3.54167C1.41667 2.37292 2.37292 1.41667 3.54167 1.41667H6.73625C6.84958 1.41667 6.97 1.41667 7.08333 1.43083V4.95833C7.08333 6.12708 8.03958 7.08333 9.20833 7.08333H13.3237C13.5433 7.08333 13.7487 6.98417 13.8833 6.80708C14.0179 6.63 14.0604 6.41042 14.0108 6.19792C13.7913 5.33375 13.345 4.5475 12.7146 3.91708L10.2496 1.45208C9.31458 0.517083 8.06792 0 6.74333 0H3.54167C1.58667 0 0 1.58667 0 3.54167V13.4583C0 15.4133 1.58667 17 3.54167 17H10.625C11.6379 17 12.6083 16.5608 13.2812 15.8029C13.5433 15.5125 13.515 15.0592 13.2175 14.8042ZM8.5 1.88417C8.76917 2.04 9.01708 2.23125 9.24375 2.45792L11.7087 4.92292C11.9283 5.1425 12.1196 5.3975 12.2754 5.66667H9.20125C8.81167 5.66667 8.49292 5.34792 8.49292 4.95833V1.88417H8.5ZM16.3837 12.8137L15.2433 13.9542C15.1017 14.0958 14.9246 14.1596 14.7404 14.1596C14.5562 14.1596 14.3792 14.0887 14.2375 13.9542C13.9613 13.6779 13.9613 13.2317 14.2375 12.9554L15.1512 12.0417H9.90958C9.52 12.0417 9.20125 11.7229 9.20125 11.3333C9.20125 10.9437 9.52 10.625 9.90958 10.625H15.1512L14.2375 9.71125C13.9613 9.435 13.9613 8.98875 14.2375 8.7125C14.5138 8.43625 14.96 8.43625 15.2362 8.7125L16.3767 9.85292C17.1912 10.6675 17.1912 11.9992 16.3767 12.8208L16.3837 12.8137Z",
    fill: "#EE4E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_1331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport1);
export default __webpack_public_path__ + "static/media/FileExport1.9d4240ae9c83608f0d1b19ea03821a8f.svg";
export { ForwardRef as ReactComponent };